export function money(value) {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(Number.isFinite(value) ? value : 0)
}

export function parseDate(dateStr) {
  const [day, month, year] = String(dateStr || "")
    .split("/")
    .map(Number)
  return new Date(year || 0, (month || 1) - 1, day || 1).getTime()
}

const SECTION_LABELS = {
  obra_nueva: "Obra nueva",
  rehabilitacion: "Rehabilitación",
  espacios_urbanos: "Espacios urbanos",
}

export function sectionLabel(section) {
  return SECTION_LABELS[section] || ""
}

export function sectionValue(label) {
  return (
    Object.keys(SECTION_LABELS).find(key => SECTION_LABELS[key] === label) ||
    null
  )
}
